import { Card, Flex, Tag, Typography } from 'antd';
import {
  IconArrowRight,
  IconBuilding,
  IconBuildingFactory2,
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import type { PartnerOrgSelection } from '@/app/landing/sla/shared/types';

const { Text, Title } = Typography;

type Props = {
  partner: PartnerOrgSelection | null;
  variant: 'landlord' | 'oem';
  operatorOrganizationName: string;
};

export function PartnerHeroCard({
  partner,
  variant,
  operatorOrganizationName,
}: Props) {
  const { t } = useTranslation('sla');
  const Icon = variant === 'landlord' ? IconBuilding : IconBuildingFactory2;
  const accent = variant === 'landlord' ? '#1e6df6' : '#7c3aed';
  const partnerLabel =
    variant === 'landlord' ? t('hero.landlordPartner') : t('hero.oemPartner');

  return (
    <Card
      style={{
        borderRadius: 16,
        border: `1px solid ${accent}22`,
        background: `linear-gradient(135deg, ${accent}08 0%, #ffffff 55%)`,
      }}
      styles={{ body: { padding: 24 } }}
    >
      <Flex vertical align="center" gap={16}>
        <div
          style={{
            width: 72,
            height: 72,
            borderRadius: 20,
            background: `${accent}14`,
            color: accent,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon size={34} stroke={1.6} />
        </div>

        <div style={{ textAlign: 'center' }}>
          <Tag
            color={variant === 'landlord' ? 'blue' : 'purple'}
            style={{ borderRadius: 9999, marginBottom: 8 }}
          >
            {partnerLabel}
          </Tag>
          <Title level={3} style={{ margin: 0, letterSpacing: '-0.02em' }}>
            {partner?.name ?? '—'}
          </Title>
          <Text type="secondary">{t('hero.readyToLink')}</Text>
        </div>

        <Flex align="center" gap={12} style={{ width: '100%' }}>
          <Card
            size="small"
            style={{ flex: 1, borderRadius: 12, border: '1px solid #e2e8f0' }}
          >
            <Text strong>{operatorOrganizationName}</Text>
            <div>
              <Text type="secondary" className="ds-small-label">
                {t('hero.yourOrganization')}
              </Text>
            </div>
          </Card>
          <IconArrowRight size={18} color="#8d969e" />
          <Card
            size="small"
            style={{
              flex: 1,
              borderRadius: 12,
              border: `1px solid ${accent}33`,
              background: `${accent}06`,
            }}
          >
            <Text strong>{partner?.name ?? '—'}</Text>
            <div>
              <Text type="secondary" className="ds-small-label">
                {partnerLabel}
              </Text>
            </div>
          </Card>
        </Flex>
      </Flex>
    </Card>
  );
}
